// contact us



$(document).ready(function () {
	$('#contact-form').submit(function(event) {
		
	    if (typeof grecaptcha !== 'undefined') {
	        var resp = grecaptcha.getResponse();
	        if (resp.length == 0) {
	        	event.preventDefault();
	            $("#captchaError").show().html("Please verify that you are not a robot.");
	            return;
	        }
	    }
    });
});

